import { createConfirmationService } from '@shared/api'
import { authorizedHttpClient } from './http-client'

export const ConfirmationService = createConfirmationService(authorizedHttpClient, import.meta.env.VITE_API_URL)
